<template>
  <div class="flex flex_column">
    <Header />
    <div class="personalInfo">
      <div class="container flex" style="align-items: flex-start;">
        <div class="siderbar">
          <div class="navTitle"></div>
          <el-menu
            :router="false"
            :default-active="activeIndex"
            @open="handleOpen"
            @close="handleClose"
            @select="handleSelect"
          >
            <el-menu-item index="/personal/index">
              <i
                :class="
                  `nIcon grxx ${
                    activePath[0] === '/personal/index' ? 'grxx_active' : ''
                  }`
                "
              ></i>
              <span slot="title">数据档案</span>
            </el-menu-item>
            <el-menu-item index="/personal/report/list">
              <i
                :class="
                  `nIcon grxxbg ${
                    activePath[0] === '/personal/report/list'
                      ? 'grxxbg_active'
                      : ''
                  }`
                "
              ></i>
              <span slot="title">信息报告</span>
            </el-menu-item>
            <el-menu-item index="/personal/reportCheck/list">
              <i
                :class="
                  `nIcon bgcysq ${
                    activePath[0] === '/personal/reportCheck/list'
                      ? 'bgcysq_active'
                      : ''
                  }`
                "
              ></i>
              <span slot="title">查验申请处理</span>
            </el-menu-item>
            <el-menu-item index="/personal/checkOthers/index">
              <i
                :class="
                  `nIcon cytr ${
                    activePath[0] === '/personal/checkOthers/index'
                      ? 'cytr_active'
                      : ''
                  }`
                "
              ></i>
              <span slot="title">查验他人</span>
            </el-menu-item>
            <el-menu-item index="/personal/corrigendumRecord">
              <i
                :class="
                  `nIcon kwjl ${
                    activePath[0] === '/personal/corrigendumRecord'
                      ? 'kwjl_active'
                      : ''
                  }`
                "
              ></i>
              <span slot="title">勘误记录</span>
            </el-menu-item>
            <!-- <el-menu-item index="/personal/report/list">
              <i :class=" `nIcon grxxbg ${ activePath[0] === '/personal/report/list' ? 'grxxbg_active' : '' }`" ></i>
              <span slot="title">信息报告</span>
            </el-menu-item> -->
          </el-menu>
          <!-- <el-menu
            :default-active="activeIndex"
            :router="false"
            @open="handleOpen"
            @close="handleClose"
            @select="handleSelect"
          >
            <el-submenu index="/personal/index">
              <template slot="title">
                <i
                  :class="
                    `nIcon grxx ${
                      activePath[1] === '/personal/index'
                        ? 'grxx_active'
                        : activePath[1] === '/personal/corrigendumRecord'
                        ? 'grxx_active'
                        : ''
                    }`
                  "
                ></i>
                <span>&nbsp;数据档案</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/personal/index">数据档案</el-menu-item>
                <el-menu-item index="/personal/corrigendumRecord"
                  >勘误记录</el-menu-item
                >
              </el-menu-item-group>
            </el-submenu>

            <el-menu-item index="/personal/report/list">
              <i
                :class="
                  `nIcon grxxbg ${
                    activePath[0] === '/personal/report/list'
                      ? 'grxxbg_active'
                      : ''
                  }`
                "
              ></i>
              <span slot="title">信息报告</span>
            </el-menu-item>

            <el-menu-item index="/personal/reportCheck/list">
              <i
                :class="
                  `nIcon bgcysq ${
                    activePath[0] === '/personal/reportCheck/list'
                      ? 'bgcysq_active'
                      : ''
                  }`
                "
              ></i>
              <span class="new" slot="title"
                >查验申请处理<i v-if="redDot" class="icon_new"
              /></span>
            </el-menu-item>

            <el-submenu index="/personal/checkOthers/index">
              <template slot="title">
                <i
                  :class="
                    `nIcon cytr ${
                      activePath[0] === '/personal/checkOthers/index'
                        ? 'cytr_active'
                        : ''
                    }`
                  "
                ></i>
                <span>&nbsp;查验他人</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/personal/checkOthers/index"
                  >查验他人</el-menu-item
                >
                <el-menu-item index="/personal/checkOthers/records"
                  >查验记录</el-menu-item
                >
              </el-menu-item-group>
            </el-submenu>
          </el-menu> -->
        </div>

        <router-view @redDotChange="redDotChange"></router-view>
      </div>
    </div>
    <!-- <FixedMenu /> -->
    <Footer />
  </div>
</template>

<script>
import SiderBar from "@/components/SiderBar";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { waitDeal } from "@/api/report";
import FixedMenu from "../../components/FixedMenu.vue";
import { getUserInfo } from "@/api/user";

export default {
  components: { SiderBar, Header, Footer, FixedMenu },
  data() {
    return {
      activeIndex: "index",
      activePath: ["1"],
      userInfo: undefined,
      redDot:
        JSON.parse(localStorage.getItem("redDot")) != undefined
          ? JSON.parse(localStorage.getItem("redDot"))
          : false
    };
  },
  created() {
    this.activePath = [this.$route.path];
    this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    // window.addEventListener('redDot')
    this.getUserInfo()
  },
  methods: {
    redDotChange(data) {
      this.redDot = data;
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
      // this.activeIndex = key;
    },
    handleClose() {},
    handleRedirect(path) {
      this.$router.push(path);
    },
    handleSelect(index, indexPath) {
      this.getRedDot();
      let status = JSON.parse(sessionStorage.getItem("userInfo")).status;
      if (status === "3" || status === "4") {
        this.$router.push(index);
      } else {
        if (
          index === "/personal/report/list" ||
          index === "/personal/reportCheck/list" ||
          index === "/personal/checkOthers/index" ||
          index === "/personal/checkOthers/records" ||
          index === "/personal/corrigendumRecord"
        ) {
          this.$message.error("请先进行实名认证");
        } else {
          this.$router.push(index);
        }
      }

      this.activeIndex = index;
      this.activePath = indexPath;
    },
    getRedDot() {
      waitDeal().then(res => {
        localStorage.setItem("redDot", JSON.stringify(res.data.d));
        this.redDot = res.data.d;
      });
    },
    getUserInfo() {
      getUserInfo().then(res => {
        console.log(res);
        sessionStorage.setItem("userInfo",JSON.stringify(res.data.d))
      });
    }
  }
};
</script>

<style scoped lang="scss">
.flex {
  display: flex;
}
.flex_column {
  flex-direction: column;
}
.personalInfo {
  background: #f0f2f5;
  .siderbar {
    box-sizing: border-box;
    // text-align: center;
    width: 257px;
    margin-top: 39px;
    padding: 26px 17px 346px 18px;
    background: #fff;
    .navTitle {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/menuTitle.png")
        no-repeat;
      background-size: cover;
      width: 222px;
      height: 106px;
      // color: #f9f9f9;
      // font-size: 26px;
      // padding: 36px 56px 35px 56px;
      // text-align: center;
    }
    .nIcon {
      width: 26px;
      height: 26px;
      display: inline-block;
      background: #dbdbdb;
      margin-right: 18px;
      background-size: cover !important;
    }
    .grxx {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/nMenu1.png")
        no-repeat;
    }

    .grxxbg {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/nMenu2.png")
        no-repeat;
    }
    .bgcysq {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/nMenu3.png")
        no-repeat;
    }
    .cytr {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/nMenu4.png")
        no-repeat;
    }
    .kwjl {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/nMenu9.png")
        no-repeat;
    }
    .el-menu {
      border-right: 0;
    }
    .grxx_active {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/nMenu1_active.png")
        no-repeat;
    }

    .grxxbg_active {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/nMenu2_active.png")
        no-repeat;
    }
    .bgcysq_active {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/nMenu3_active.png")
        no-repeat;
    }
    .cytr_active {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/nMenu4_active.png")
        no-repeat;
    }
    .kwjl_active {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/nMenu9_active.png")
        no-repeat;
    }
  }
}
.f15 {
  font-size: 15px;
}
.el-menu-item.is-active {
  color: #3a61b1;
  background: rgba(58, 97, 177, 0.12);
}
>>> .el-submenu .el-submenu__title {
  padding-left: 31px !important;
  font-size: 18px;
  display: flex;
  align-items: center;
}
.el-menu-item {
  padding-left: 31px !important;
  font-size: 18px;
}
.el-menu-item-group__title {
  padding: 0;
}
.el-menu-item-group {
  .el-menu-item {
    // padding-left: 40px;
    // padding-left: 31px !important;
    padding-left: 0 !important;
    padding: 0;
    text-align: center;
    line-height: 64px;
    height: 64px;
    font-size: 16px;
    // display: flex;
    // // align-items: center;
    // justify-content: space-around;
    // padding: 0 !important;
    // padding-left: -40px !important;
    // // padding-left: -30px !important;
    // // padding-left: 40px;
  }
}
.new {
  position: relative;
  .icon_new {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
    background: #ff3817;
    border: 2px solid #fff;
    position: absolute;
    left: -30px;
    top: -5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/index.vue